// A route download finishing does not mean its GeoJSON has been painted yet.
// Idle handlers can also change the camera/layers, requiring another render.
export async function waitForSportsmapPreview({
  map,
  signal,
  prepareLayout,
  finalizeLayers,
}) {
  signal.throwIfAborted();
  await prepareLayout();
  await waitForIdle(map, signal);
  signal.throwIfAborted();
  finalizeLayers();
  do {
    await waitForIdle(map, signal);
    // Another idle listener may have just changed the camera or layer order.
  } while (!map.loaded() || map.isMoving());
  signal.throwIfAborted();
}

function waitForIdle(map, signal) {
  return new Promise((resolve, reject) => {
    signal.throwIfAborted();
    const cleanup = () => {
      map.off("idle", onIdle);
      signal.removeEventListener("abort", onAbort);
    };
    const onIdle = () => {
      cleanup();
      // Promise continuations run after all handlers of this idle event,
      // including the startup camera positioning and route restoration.
      resolve();
    };
    const onAbort = () => {
      cleanup();
      reject(signal.reason);
    };
    map.on("idle", onIdle);
    signal.addEventListener("abort", onAbort, { once: true });
    // Also produce an idle event when the map was already idle on entry.
    map.triggerRepaint();
  });
}
